export default __webpack_public_path__ + "static/media/twoTomoea.909911a7.png";